
// Start: Why Waggle's Amazing?

(function () {
  const tableWrapper = document.querySelector(".table-wrapper");
  const switchInputs = document.querySelectorAll(".switch-wrapper input");
  const prices = tableWrapper.querySelectorAll(".price");
  const toggleClass = "hide";

  for (const switchInput of switchInputs) {
    switchInput.addEventListener("input", function () {
      for (const price of prices) {
        price.classList.add(toggleClass);
      }
      const activePrices = tableWrapper.querySelectorAll(
        `.price.${switchInput.id}`
      );
      for (const activePrice of activePrices) {
        activePrice.classList.remove(toggleClass);
      }
    });
  }
})();


// End: Why Waggle's Amazing?